var _path, _path2, _mask, _path3, _path4, _path5, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBatteryCharging(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 13,
    viewBox: "0 0 7 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 11.5V2.5C4.25 2.08579 3.91421 1.75 3.5 1.75C3.08579 1.75 2.75 2.08579 2.75 2.5V11.5C2.75 11.9142 3.08579 12.25 3.5 12.25C3.91421 12.25 4.25 11.9142 4.25 11.5Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.750134 2.49933C0.748996 2.98235 0.753843 3.51138 0.81078 4.00222C0.867218 4.48876 0.977599 4.96663 1.20607 5.33243C1.48304 5.77591 1.90008 6.00469 2.31882 6.12203C2.73319 6.23815 3.16595 6.25 3.5 6.25C3.83405 6.25 4.26681 6.23815 4.68118 6.12203C5.09992 6.00469 5.51696 5.77591 5.79393 5.33243C6.0224 4.96663 6.13278 4.48876 6.18922 4.00222C6.24616 3.51138 6.251 2.98235 6.24987 2.49933C6.24889 2.08503 5.91193 1.75 5.49827 1.75L3.5 1.75L1.50173 1.75C1.08806 1.75 0.75111 2.08503 0.750134 2.49933Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 0.5
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_9_4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 0.5C2 0.223858 2.22386 0 2.5 0V0C2.77614 0 3 0.223858 3 0.5V2.5C3 2.77614 2.77614 3 2.5 3V3C2.22386 3 2 2.77614 2 2.5V0.5Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 0.5C2 0.223858 2.22386 0 2.5 0V0C2.77614 0 3 0.223858 3 0.5V2.5C3 2.77614 2.77614 3 2.5 3V3C2.22386 3 2 2.77614 2 2.5V0.5Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 0.5V2.5H4V0.5H2ZM3 2.5V0.5H1V2.5H3ZM2.5 2C2.77614 2 3 2.22386 3 2.5H1C1 3.32843 1.67157 4 2.5 4V2ZM2 2.5C2 2.22386 2.22386 2 2.5 2V4C3.32843 4 4 3.32843 4 2.5H2ZM2.5 1C2.22386 1 2 0.776142 2 0.5H4C4 -0.328427 3.32843 -1 2.5 -1V1ZM2.5 -1C1.67157 -1 1 -0.328427 1 0.5H3C3 0.776142 2.77614 1 2.5 1V-1Z",
    fill: "black",
    mask: "url(#path-3-inside-1_9_4)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4 0.5C4 0.223858 4.22386 0 4.5 0V0C4.77614 0 5 0.223858 5 0.5V2.5C5 2.77614 4.77614 3 4.5 3V3C4.22386 3 4 2.77614 4 2.5V0.5Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 6,
    width: 1,
    height: 1,
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatteryCharging);
export default __webpack_public_path__ + "static/media/battery-charging.55053eceaf6b59028d8bfcc66f63d2a8.svg";
export { ForwardRef as ReactComponent };